import { Button } from '../ui/button';

export default function WorkerReadinessNotice({ blockers = [], onReview, onHelp }) {
  const labels = [...new Set(blockers.map((item) => item?.label).filter(Boolean))];
  return (
    <section aria-labelledby="worker-readiness-title" className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4 sm:p-5">
      <h2 id="worker-readiness-title" className="font-semibold text-slate-900">Your work readiness needs attention</h2>
      <p className="mt-1 text-sm text-slate-700">Review your staff file for the next steps. The team must confirm your readiness before you can be cleared for work.</p>
      {labels.length > 0 ? (
        <ul className="mt-3 list-disc space-y-1 pl-5 text-sm text-slate-700">
          {labels.slice(0, 3).map((label) => <li key={label}>{label}</li>)}
        </ul>
      ) : <p className="mt-3 text-sm text-slate-700">No specific action is listed yet. Ask the team to review your readiness.</p>}
      {labels.length > 3 ? <details className="mt-3 text-sm text-slate-700">
        <summary className="cursor-pointer py-2">Show {labels.length - 3} more items</summary>
        <ul className="list-disc space-y-1 pl-5">{labels.slice(3).map((label) => <li key={label}>{label}</li>)}</ul>
      </details> : null}
      <div className="mt-4 flex flex-wrap gap-2">
        <Button className="min-h-11 rounded-xl" onClick={onReview}>Review my staff file</Button>
        <Button variant="outline" className="min-h-11 rounded-xl" onClick={onHelp}>Ask for help</Button>
      </div>
    </section>
  );
}
